import { publicEnv } from '@/constants/publicEnv.ts'

export const PaymentMetaCreem = {
  personal: {
    link: publicEnv.EXPO_PUBLIC_CREEM_PERSONAL_LINK,
    cost: 79,
    seats: 1,
    productId: publicEnv.EXPO_PUBLIC_CREEM_PRODUCT_ID_PERSONAL,
  },
  team: {
    link: publicEnv.EXPO_PUBLIC_CREEM_TEAM_LINK,
    cost: 249,
    seats: 15,
    productId: publicEnv.EXPO_PUBLIC_CREEM_PRODUCT_ID_TEAM,
  },
} as const

export const PaymentMeta = PaymentMetaCreem
